import { BorderProps } from '../../atoms/Border';
import { StepNumberProps } from '../../atoms/StepNumber';
import { TextProps } from '../../atoms/Text';


type StepLabelInternalProps = {
  stepNumber?: StepNumberProps;
  text?: TextProps;
  border?: BorderProps;
};

type StepLabelPropsValues = {
  'ActiveDefault': StepLabelInternalProps;
  'ActiveEnd': StepLabelInternalProps;
  'CompletedDefault': StepLabelInternalProps;
  'CompletedEnd': StepLabelInternalProps;
  'DisabledDefault': StepLabelInternalProps;
  'DisabledEnd': StepLabelInternalProps;
};

const propValues: StepLabelPropsValues = {
  'ActiveDefault': {
    stepNumber: {
      state: 'Active',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Positive',
      type: 'Body1',
    },
    border: {
      colour: 'Line1',
      type: 'Horizontal',
      styleType: 'Dashed',
    },
  },
  'ActiveEnd': {
    stepNumber: {
      state: 'Active',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Positive',
      type: 'Body1',
    },
  },
  'CompletedDefault': {
    stepNumber: {
      state: 'Completed',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Positive',
      type: 'Body1',
    },
    border: {
      colour: 'Positive',
      type: 'Horizontal',
      styleType: 'Default',
    },
  },
  'CompletedEnd': {
    stepNumber: {
      state: 'Completed',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Positive',
      type: 'Body1',
    },
  },
  'DisabledDefault': {
    stepNumber: {
      state: 'Disabled',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Subdued',
      type: 'Body1',
    },
    border: {
      colour: 'Line1',
      type: 'Horizontal',
      styleType: 'Dashed',
    },
  },
  'DisabledEnd': {
    stepNumber: {
      state: 'Disabled',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Subdued',
      type: 'Body1',
    },
  },
};

const getProps = (type: string): StepLabelInternalProps => {
  const values: StepLabelInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
